import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import './MoveInDate.css';

interface MoveInDateData {
  date: string;
}

const MoveInDate: React.FC = () => {
  const { propertyId, unitNumber } = useParams<{ propertyId: string; unitNumber: string }>();
  const [moveInDate, setMoveInDate] = useState<string | null>(null);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const fetchMoveInDate = async () => {
      try {
        const effectivePropertyId = propertyId || localStorage.getItem('selectedPropertyId');
        const effectiveUnitNumber = unitNumber || localStorage.getItem('selectedUnitNumber');

        if (!effectivePropertyId || !effectiveUnitNumber) {
          throw new Error('Missing property or unit information');
        }

        const response = await fetch(
          `https://${process.env.REACT_APP_BASE_URL}/getMoveInDate/${effectivePropertyId}/${effectiveUnitNumber}`
        );
        const data: MoveInDateData[] = await response.json();
        setMoveInDate(data[0].date);
      } catch (error) {
        console.error('Error fetching move-in date:', error);
      } finally {
        setIsLoading(false);
      }
    };

    fetchMoveInDate();
  }, [propertyId, unitNumber]);

  if (isLoading) {
    return <div className="move-in-date-loading">Loading move-in date...</div>;
  }

  if (!moveInDate) {
    return <div>No move-in date available</div>;
  }

  const formattedDate = new Date(moveInDate).toLocaleDateString('en-US', {
    year: 'numeric',
    month: 'long',
    day: 'numeric'
  });

  return (
    <div className="move-in-date">
      <h3>First Available Date</h3>
      <p>{formattedDate}</p>
    </div>
  );
};

export default MoveInDate; 